import { LuIcon, Menu, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import type { Project } from "@overmap-ai/common"
import { memo, type ReactElement, useCallback } from "react"

import { ProjectNameFilterDef } from "../../filtering/defs/ProjectNameFilterDef"
import { FilterManager } from "../../filtering/manager"
import { modelIconMapping } from "../../mappings/icons"

export interface ProjectFilterMenuProps extends MenuRootProps, MenuVariantProps {
	children: ReactElement
	filterManager: FilterManager<Project>
}

export const ProjectFilterMenu = memo<ProjectFilterMenuProps>((props) => {
	const { children, variant, size, accentColor, filterManager, ...rest } = props

	const handleSelectName = useCallback(() => {
		filterManager.addFilter(new ProjectNameFilterDef().createFilter())
	}, [filterManager])

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger>{children}</Menu.ClickTrigger>
			<Menu.Content variant={variant} size={size} accentColor={accentColor}>
				<Menu.Scroll>
					<Menu.Item onSelect={handleSelectName}>
						<LuIcon icon={modelIconMapping.text} />
						Name
					</Menu.Item>
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
ProjectFilterMenu.displayName = "ProjectFilterMenu"
